/**
 * ? @description : Primary Information Component
 */

// Dependencies
import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";

// CSS Component
import "./FormInfo.css";
import Axios from "../teacherapi/TeacherApi";
import { Snackbar } from "@mui/material";
import Alert from "@mui/material/Alert";
export default function PrimaryInfo({
  formData,
  setFormData,
  validationRes,
  setValidationRes,
}) {
  const [otp, setOtp] = useState("");

  const [alert, setAlert] = useState({
    open: false,
    severity: "error" | "info" | "success" | "warning",
    message: "",
  });

  const chosenLanguages = [
    formData.spoke_lang_1,
    formData.spoke_lang_2,
    formData.spoke_lang_3,
    formData.spoke_lang_4,
    formData.spoke_lang_5,
    formData.spoke_lang_6,
  ].filter((data) => data);

  const checkInvalidEmail = (email) => {
    var pattern = new RegExp(
      /^(([\w.+-]+)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    var result = pattern.test(email);
    return !result;
  };

  const [isVerifyOtpTriggered, setIsVerifyOtpTriggered] = useState({
    isSuccess: false,
    isLoading: false,
    isError: false,
    data: null,
  });
  const [isEmailVerified, setEmailVerified] = useState({
    isLoading: false,
    isError: false,
    isSuccess: false,
    data: null,
  });

  const [verifyOtp, setVerifyOtp] = useState({
    isLoading: false,
    isError: false,
    isSuccess: false,
    data: null,
  });

  const triggerOTPRequest = async () => {
    try {
      setIsVerifyOtpTriggered((prev) => ({ ...prev, isLoading: true }));

      let options = {
        method: "POST",
        url: "/teacher/send/otp",
        auth: true,
        data: {
          email: formData.email,
          is_teacher: true,
        },
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      if (response.status === 200) {
        setIsVerifyOtpTriggered((prev) => ({
          ...prev,
          isLoading: false,
          isError: false,
          isSuccess: true,
          data: response.data,
        }));
        setAlert({
          open: true,
          severity: "success",
          message: response.data.message,
        });
      }
    } catch (error) {
      console.log(error);
      setAlert({
        open: true,
        message: "mail id already existed, Please try with some other Email id",
      });
      setIsVerifyOtpTriggered((prev) => ({
        ...prev,
        isLoading: false,
        isError: true,
        data: null,
        isSuccess: false,
      }));
    }
  };

  useEffect(() => {
    if (otp.length === 6) {
      (async () => {
        try {
          setVerifyOtp((prev) => ({
            ...prev,
            isLoading: true,
            isError: false,
            data: null,
            isSuccess: false,
          }));

          let options = {
            method: "POST",
            url: "/teacher/verify/email",
            auth: true,
            data: {
              email: formData.email,
              otp: otp,
            },
          };

          const response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data
          );

          if (response.status === 200) {
            setVerifyOtp((prev) => ({
              ...prev,
              isLoading: false,
              isError: false,
              isSuccess: true,
              data: response.data,
            }));
            setFormData((prev) => ({ ...prev, isOTPVerified: true }));
          }
        } catch (error) {
          console.log(error);
          setVerifyOtp((prev) => ({
            ...prev,
            isLoading: false,
            isError: true,
            data: null,
            isSuccess: false,
          }));
          alert(error.data.message);
          setAlert({
            open: true,
            severity: "error",
            message: error.data.message,
          });
        }
      })();
    }
  }, [otp]);

  useEffect(() => {
    if (verifyOtp.isSuccess) {
      setValidationRes({
        ...validationRes,
        isInvalidOTP: false,
      });
    }
  }, [verifyOtp.isSuccess]);

  useEffect(() => {
    if (!checkInvalidEmail(formData.email)) {
      (async () => {
        try {
          setEmailVerified((prev) => ({
            ...prev,
            isLoading: true,
            isError: false,
            data: null,
            isSuccess: false,
          }));

          let options = {
            method: "POST",
            url: "/teacher/check/email/verification",
            auth: true,
            data: {
              email: formData.email,
              is_teacher: false,
            },
          };

          const response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data
          );

          if (response.status === 200) {
            setEmailVerified((prev) => ({
              ...prev,
              isLoading: false,
              isError: false,
              isSuccess: true,
              data: response.data.verifiedEmail ? "verified" : "unverified",
            }));
            setFormData((prev) => ({
              ...prev,
              isOTPVerified: response.data.verifiedEmail ? true : false,
            }));
          }
        } catch (error) {
          console.log(error);
          setEmailVerified((prev) => ({
            ...prev,
            isLoading: false,
            isError: true,
            data: null,
            isSuccess: false,
          }));
              alert(error.data.message);
          setAlert({
            open: true,
            severity: "error",
            message: error.data.message,
          });
        }
        
      })();
    } else {
      setEmailVerified((prev) => ({
        ...prev,
        isLoading: false,
        isError: false,
        isSuccess: false,
        data: false,
      }));
      setFormData((prev) => ({
        ...prev,
        isOTPVerified: false,
      }));
    }
  }, [formData.email]);

  useEffect(() => {
    setFormData((prev) => ({ ...prev, isOTPVerified: false }));
    setOtp("");
    setIsVerifyOtpTriggered((prev) => ({
      ...prev,
      isLoading: false,
      isError: false,
      data: null,
      isSuccess: false,
    }));
    setVerifyOtp((prev) => ({
      ...prev,
      isLoading: false,
      isError: false,
      data: null,
      isSuccess: false,
    }));
  }, [formData.email]);

  return (
    <div>
      <Snackbar
        open={alert.open}
        autoHideDuration={3000}
        onClose={() => setAlert((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          severity={alert.severity}
          onClose={() => setAlert((prev) => ({ ...prev, open: false }))}
          sx={{ width: "100%" }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
      <Form>
        <Form.Group className="mb-3 form-info">
          <Form.Label>
            Name <span style={{ color: "red" }}>*</span>
          </Form.Label>

          <Form.Control
            type="name"
            name="teacher_name"
            placeholder="Enter Your Name"
            // style={{ width: "250px" }}
            value={formData.teacher_name}
            onChange={(event) => {
              setFormData({ ...formData, teacher_name: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidTeacherName: false,
                isInvalidTeacherNameFormate: false,
              });
            }}
            isInvalid={
              validationRes.isInvalidTeacherName ||
              validationRes.isInvalidTeacherNameFormate
            }
          />
          <Form.Text>
            Note:- Only alphabetical letters of max 50 characters are allowed{" "}
          </Form.Text>

          <Form.Control.Feedback type="invalid">
            {validationRes.isInvalidTeacherName
              ? " Name is mandatory and should be less than 50 characters."
              : ""}
            {validationRes.isInvalidTeacherNameFormate
              ? "The volunteer name name should consist only of alphabetical values."
              : ""}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>
            Mobile Number <span style={{ color: "red" }}>*</span>
          </Form.Label>

          <Form.Control
            type="tel"
            name="contactno"
            placeholder="Enter Your Number"
            // style={{ width: "250px" }}
            value={formData.contactno}
            onChange={(event) => {
              setFormData({ ...formData, contactno: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidTeacherMobileNumber: false,
                isInvalidTeacherMobileNumberFormate: false,
              });
            }}
            isInvalid={
              validationRes.isInvalidTeacherMobileNumber ||
              validationRes.isInvalidTeacherMobileNumberFormate
            }
          />

          <Form.Control.Feedback type="invalid">
            {validationRes.isInvalidTeacherMobileNumber
              ? "Mobile number must contains 10 digits."
              : ""}
            {validationRes.isInvalidTeacherMobileNumberFormate
              ? "Mobile number is not valid"
              : ""}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label className="email_label">
         <p style={{
          display:"inline-block"
         }}> Email ID <span style={{ color: "red" }}>*</span></p>  
            <Form.Text>Please verify the OTP sent to your email.</Form.Text>
          </Form.Label>

          <Form.Control
            type="email"
            name="email"
            placeholder="Your Email Id"
            // style={{ width: "250px" }}
            value={formData.email}
            onChange={(event) => {
              setFormData({
                ...formData,
                email: event.target.value.toLocaleLowerCase(),
              });
              setIsVerifyOtpTriggered((prev) => ({
                ...prev,
                isLoading: false,
                isError: false,
                isSuccess: false,
                data: null,
              }));
              setValidationRes({
                ...validationRes,
                isInvalidTeacherMailId: false,
              });
            }}
            isInvalid={validationRes.isInvalidTeacherMailId}
          />
             {isEmailVerified.isLoading && (
            <span className="mt-1 text-success">
              Verifying....
            </span>
          )}
          {!checkInvalidEmail(formData.email) && !formData.isOTPVerified && isEmailVerified.data === 'unverified' && (
            <Button
              onClick={triggerOTPRequest}
              disabled={isVerifyOtpTriggered.isLoading}
              className="mt-1"
              size="sm"
              type="button"
            >
              {isVerifyOtpTriggered.isLoading
                ? "sending..."
                : isVerifyOtpTriggered.isSuccess
                ? "Resend"
                : "Verify OTP"}
            </Button>
          )}

          {formData.isOTPVerified && (
            <span className="mt-1 text-success">
              Email Verified Successfully
            </span>
          )}

          <Form.Control.Feedback type="invalid">
            Enter valid Email Id
          </Form.Control.Feedback>
        </Form.Group>

        {isVerifyOtpTriggered.isSuccess && !formData.isOTPVerified && (
          <Form.Group className="mb-3 form-info">
            <Form.Label>
            
              Enter OTP <span style={{ color: "red" }}>*</span>
            </Form.Label>

            <Form.Control
              type="text"
              name="otp"
              placeholder="Enter OTP"
              value={otp}
              isInvalid={validationRes.isInvalidOTP}
              onChange={(e) => {
                setValidationRes({
                  ...validationRes,
                  isInvalidOTP: false,
                });
                if (e.target.value.length <= 6) {
                  setOtp(e.target.value);
                }
              }}
              onKeyDown={(e) => {
                if (otp.length >= 6 && e.key !== "Backspace") {
                  e.preventDefault();
                }
              }}
            />

            {verifyOtp.isLoading && (
              <span className="mt-1 text-warning">Verifying...</span>
            )}
            {verifyOtp.isSuccess && (
              <span className="mt-1 text-success">
                Email Verified Successfully
              </span>
            )}
            {verifyOtp.isError && (
              <span className="mt-1 text-danger">Invalid OTP</span>
            )}

            <Form.Control.Feedback type="invalid">
              Email must be verified
            </Form.Control.Feedback>
          </Form.Group>
        )}

        <Form.Group className="mb-3 form-info">
          <Form.Label>
            Spoken Language - 1 <span style={{ color: "red" }}>*</span>
          </Form.Label>

          {/* <Form.Control
            type="text"
            name="spoke_lang_1"
            placeholder="First Language"
            value={formData.spoke_lang_1}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_1: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidSpokenLanguage1: false,
              });
            }}
            isInvalid={validationRes.isInvalidSpokenLanguage1}
          /> */}

          <Form.Control
            as="select"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_1}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_1: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidSpokenLanguage1: false,
              });
            }}
            isInvalid={validationRes.isInvalidSpokenLanguage1}
          >
            <option value="">Select one language</option>
            {[
              "English",
              "Hindi",
              "Kannada",
              "Malayalam",
              "Tamil",
              "Telugu",
              "Urdu",
            ].map((item) => (
              <option
                disabled={chosenLanguages.some((data) => data === item)}
                key={`spoken-language-1-${item}`}
                value={item}
              >
                {item}
              </option>
            ))}
          </Form.Control>

          <Form.Control.Feedback type="invalid">
            Spoken Language is mandatory.
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 2</Form.Label>

          {/* <Form.Control
            type="text"
            name="spoke_lang_2"
            placeholder="Second Language"
            value={formData.spoke_lang_2}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_2: event.target.value });
              setValidationRes({
                ...validationRes,
                isInvalidSpokenLanguage2: false,
              });
            }}
            isInvalid={validationRes.isInvalidSpokenLanguage2}
          /> */}

          <Form.Control
            as="select"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_2}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_2: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            {[
              "English",
              "Hindi",
              "Kannada",
              "Malayalam",
              "Tamil",
              "Telugu",
              "Urdu",
            ].map((item) => (
              <option
                disabled={chosenLanguages.some((data) => data === item)}
                key={`spoken-language-2-${item}`}
                value={item}
              >
                {item}
              </option>
            ))}
          </Form.Control>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 3</Form.Label>

          <Form.Control
            as="select"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_3}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_3: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            {[
              "English",
              "Hindi",
              "Kannada",
              "Malayalam",
              "Tamil",
              "Telugu",
              "Urdu",
            ].map((item) => (
              <option
                disabled={chosenLanguages.some((data) => data === item)}
                key={`spoken-language-3-${item}`}
                value={item}
              >
                {item}
              </option>
            ))}
          </Form.Control>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 4</Form.Label>

          <Form.Control
            as="select"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_4}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_4: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            {[
              "English",
              "Hindi",
              "Kannada",
              "Malayalam",
              "Tamil",
              "Telugu",
              "Urdu",
            ].map((item) => (
              <option
                disabled={chosenLanguages.some((data) => data === item)}
                key={`spoken-language-4-${item}`}
                value={item}
              >
                {item}
              </option>
            ))}
          </Form.Control>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 5</Form.Label>

          <Form.Control
            as="select"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_5}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_5: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            {[
              "English",
              "Hindi",
              "Kannada",
              "Malayalam",
              "Tamil",
              "Telugu",
              "Urdu",
            ].map((item) => (
              <option
                disabled={chosenLanguages.some((data) => data === item)}
                key={`spoken-language-5-${item}`}
                value={item}
              >
                {item}
              </option>
            ))}
          </Form.Control>
        </Form.Group>

        <Form.Group className="mb-3 form-info">
          <Form.Label>Spoken Language - 6</Form.Label>

          <Form.Control
            as="select"
            // style={{ width: "250px" }}
            value={formData.spoke_lang_6}
            onChange={(event) => {
              setFormData({ ...formData, spoke_lang_6: event.target.value });
            }}
          >
            <option value="">Select one language</option>
            {[
              "English",
              "Hindi",
              "Kannada",
              "Malayalam",
              "Tamil",
              "Telugu",
              "Urdu",
            ].map((item) => (
              <option
                disabled={chosenLanguages.some((data) => data === item)}
                key={`spoken-language-6-${item}`}
                value={item}
              >
                {item}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
      </Form>
    </div>
  );
}
